export const Globals = {
  colorRed: "#EB1D36",
  colorBlue: "#2f58cd",
  colorGray: "#999898",
  colorWhite: "#ffffff",
  colorDarkBlue: "#344767",
};
